<template>
  <div v-loading="loading">
    <el-page-header
      @back="goBack"
      class="page_header"
      :content="title"
    ></el-page-header>
    <span>账号：{{ username }}</span>
    <template>
      <div class="title">{{ title }}</div>
      <el-table
        v-if="disease.length > 0"
        border
        :data="disease"
        style="width: 100%"
      >
        <el-table-column prop="甲状腺疾病" label="甲状腺疾病次数">
          <template slot-scope="scope">
            <span class="link" @click="show_disease_info_data('甲状腺疾病')">{{
              scope.row.甲状腺疾病
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="心脏疾病" label="心脏疾病次数">
          <template slot-scope="scope">
            <span class="link" @click="show_disease_info_data('心脏疾病')">{{
              scope.row.心脏疾病
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="肿瘤疾病" label="肿瘤疾病次数">
          <template slot-scope="scope">
            <span class="link" @click="show_disease_info_data('肿瘤疾病')">{{
              scope.row.肿瘤疾病
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="性激素" label="性激素疾病次数">
          <template slot-scope="scope">
            <span class="link" @click="show_disease_info_data('性激素')">{{
              scope.row.性激素
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="其他" label="其他疾病次数">
          <template slot-scope="scope">
            <span>{{ scope.row.其他 }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div v-else>
        <span>暂无疾病因素</span>
      </div>
    </template>

    <template v-if="disease_info.data.length > 0">
      <div class="title">{{ disease_info.name + '次数' }}</div>
      <el-table border :data="disease_info.data" style="width: 100%">
        <el-table-column prop="name" label="疾病名称" align="center" >
        </el-table-column>
        <el-table-column prop="number" label="次数" align="center" >
        </el-table-column>
      </el-table>
    </template>
  </div>
</template>

<script>
import {get_disease_factors_data,get_disease_factors_data_info} from "@/api/DataSearch";

export default {
  name: "disease_factors",
  props: {
    username: {
      type: String
    },
    user_id: {
      type: Number
    },
    factor_name: {
      type: String
    },
    title: {
      type: String
    },
    name: {
      type: String
    },
  },
  data() {
    return {
      disease: [],
      disease_info: {
        name: '',
        data: []
      },
      data: {},
      loading: false
    }
  },
  created() {
    this.get_disease_factors_data()
    // this.loading = true
    // get_disease_factors_data(this.conversation_ids).then(res => {
    //   this.loading = false
    //   const {data} = res
    //   if (data['code'] === 200) {
    //     const disease = {
    //       '甲状腺疾病': 0,
    //       '心脏疾病': 0,
    //       '性激素': 0,
    //       '肿瘤疾病': 0,
    //       '其他': 0,
    //     }
    //     const disease_data = data['influence_factor_dist']['疾病因素']['disease_type']
    //     for (const key in disease_data) {
    //       disease[key] = disease_data[key]['number']
    //     }
    //     this.$set(this.disease, 'data', [disease])

    //     this.data = data['influence_factor_dist']
    //   }
    // })
  },
  methods: {
    get_disease_factors_data(){
      this.loading = true
      const params = {
        user_id: this.user_id,
        factor_code: this.factor_name
      }
      get_disease_factors_data(params).then(res => {
        this.loading = false
        const {data} = res

        if (data['code'] === 200) {
          const disease = {}

          data.data.forEach(item => {
            disease[item.disease_name] = item.count
          });

          this.disease.push(disease)
        }
      })
    },

    goBack() {
      this.$router.push('/bec/static')
    },
    show_disease_info_data(name) {
      const params = {
        user_id: this.user_id,
        factor_code: this.factor_name,
        disease_type: name
      }
      this.loading = true
      get_disease_factors_data_info(params).then(res => {
        this.loading = false
        const {data} = res
        if (data['code'] === 200) {
          const disease_info = []
          data.data.forEach(item => {
            disease_info.push({
              name: item.disease_keyword,
              number: item.count
            })
          })
          this.disease_info.name = name
          this.$set(this.disease_info, 'data', disease_info)
        }
      })
    }
  },
  computed: {}
}
</script>

<style scoped lang="scss">
.page_header {
  margin-bottom: 20px;
}

.title {
  border-left: 5px solid #983cc9;
  margin: 30px 0;
  padding-left: 20px;
}

.link {
  color: #266fff;
  cursor: pointer;
}
</style>
